/**
 * @file select-plan-date-review.tsx
 * @module app/modals/select-plan-date-review
 * @description Renders the select plan date review modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Modal, Button, Col, Row, Card } from "react-bootstrap";
import CrossSvg from "../../_admin/assets/media/close.png";
import { useEffect, useState } from "react";
import Method from "../../utils/methods";
import clsx from "clsx";
import APICallService from "../../api/apiCallService";
import { routePlanning } from "../../api/apiEndPoints";
import { OrdersDelivery } from "../../utils/constants";
import { IMAGES } from "../../utils/assetsAndPermissions";
import Loader from "../../Global/loader";
const SelectPlanDateReview = (props: any) => {
  const [selectedToday, setSelectedToday] = useState<boolean>(true);
  const [selectedTomorrow, setSelectedTomorrow] = useState<boolean>(false);
  const [selectedNextDay, setSelectedNextDay] = useState<boolean>(false);
  const [vehicleResponse, setVehicleResponse] = useState<any>();
  const [selectedVehicle, setSelectedVehicle] = useState<any>([]);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showAllDistricts, setShowAllDistricts] = useState<{
    [key: number]: boolean;
  }>({});

  const handleVehicleSelect = (id: string) => {
    let temp = [...selectedVehicle];
    if (temp.includes(id)) {
      temp = temp.filter((item) => item != id);
    } else {
      temp.push(id);
    }
    // if (temp.length) {
    //   setValidation(false);
    // } else {
    //   setValidation(true);
    // }
    setSelectedVehicle(temp);
  };
  const handleSelectAll = () => {
    let temp: any = [];
    if (selectedVehicle.length !== vehicleResponse?.length) {
      vehicleResponse?.map((val: any) => {
        temp.push(val._id);
      });
    }
    // if (temp.length) {
    //   setValidation(false);
    // } else {
    //   setValidation(true);
    // }
    setSelectedVehicle(temp);
  };

  const fetchVehicle = async () => {
    setLoader(true);
    let apiService = new APICallService(
      routePlanning.availableVehicles,
      "",
      "",
      "",
      "",
      "",
      OrdersDelivery
    );
    let response = await apiService.callAPI();
    setVehicleResponse(response);
    setLoader(false);
  };

  useEffect(() => {
    fetchVehicle();
  }, []);

  const toggleShowAllDistricts = (index: number) => {
    setShowAllDistricts((prevState: any) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };
  return (
    <>
      <Modal
        {...props}
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-lg-450px"
        className="border-r10px"
        contentClassName="p-5"
        centered
        backdrop={props.loading ? "static" : true}
        size="xl"
      >
        <Modal.Header className="border-bottom-0 pb-0">
          <div className="w-100 d-flex align-items-center justify-content-between">
            <div className="flex-grow-1 text-center">
              <Modal.Title className="fs-26 fw-bolder">
                Generate plan for the following date
              </Modal.Title>
            </div>
            <div className="text-end">
              <Button className="uw-btn uw-btn-primary" onClick={props.onHide}>{"Close"}</Button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="container text-center">
            <Row className="d-flex justify-content-center">
              <Col
                lg={12}
                md={12}
                xs={12}
                className="d-flex justify-content-center"
              >
                <Col
                  xs={4}
                  lg={4}
                  md={4}
                  className={clsx(
                    selectedToday
                      ? "bg-primary border rounded w-150px py-4 px-4 me-2 text-white"
                      : "bg-light border rounded w-150px py-4 px-4 me-2"
                  )}
                  onClick={() => {
                    setSelectedToday(true);
                    setSelectedTomorrow(false);
                    setSelectedNextDay(false);
                  }}
                >
                  <Col className="d-flex justify-content-center">
                    <div className="form-check form-check-custom form-check-solid">
                      <p
                        className={clsx(
                          selectedToday
                            ? "form-check-label fs-16 fw-600 text-white"
                            : "form-check-label fs-16 fw-600 text-dark"
                        )}
                      >
                        For Today{" "}
                      </p>
                    </div>
                  </Col>
                  <Col className="d-flex justify-content-center">
                    <div className="form-check form-check-custom form-check-solid">
                      <p
                        className={clsx(
                          selectedToday
                            ? "form-check-label fs-16 fw-600 text-white"
                            : "form-check-label fs-16 fw-600 text-dark"
                        )}
                      >
                        {Method.getDateAfterDays(
                          Method.getTodayDate("DD-MM-YYYY"),
                          0,
                          "DD-MM-YYYY"
                        )}
                      </p>
                    </div>
                  </Col>
                </Col>
                <Col
                  xs={4}
                  lg={4}
                  md={4}
                  className={clsx(
                    selectedTomorrow
                      ? "bg-primary border rounded w-150px py-4 px-4 me-2 text-white"
                      : "bg-light border rounded w-150px py-4 px-4 me-2"
                  )}
                  onClick={() => {
                    setSelectedToday(false);
                    setSelectedTomorrow(true);
                    setSelectedNextDay(false);
                  }}
                >
                  <Col className="d-flex justify-content-center">
                    <div className="form-check form-check-custom form-check-solid">
                      <p
                        className={clsx(
                          selectedTomorrow
                            ? "form-check-label fs-16 fw-600 text-white"
                            : "form-check-label fs-16 fw-600 text-dark"
                        )}
                      >
                        For Tomorrow{" "}
                      </p>
                    </div>
                  </Col>
                  <Col className="d-flex justify-content-center">
                    <div className="form-check form-check-custom form-check-solid">
                      <p
                        className={clsx(
                          selectedTomorrow
                            ? "form-check-label fs-16 fw-600 text-white"
                            : "form-check-label fs-16 fw-600 text-dark"
                        )}
                      >
                        {Method.getDateAfterDays(
                          Method.getTodayDate("DD-MM-YYYY"),
                          1,
                          "DD-MM-YYYY"
                        )}
                      </p>
                    </div>
                  </Col>
                </Col>
                <Col
                  xs={4}
                  lg={4}
                  md={4}
                  className={clsx(
                    selectedNextDay
                      ? "bg-primary border rounded w-150px py-4 px-4 me-2 text-white"
                      : "bg-light border rounded w-150px py-4 px-4 me-2"
                  )}
                  onClick={() => {
                    setSelectedToday(false);
                    setSelectedTomorrow(false);
                    setSelectedNextDay(true);
                  }}
                >
                  <Col className="d-flex justify-content-center">
                    <div className="form-check form-check-custom form-check-solid">
                      <p
                        className={clsx(
                          selectedNextDay
                            ? "form-check-label fs-16 fw-600 text-white"
                            : "form-check-label fs-16 fw-600 text-dark"
                        )}
                      >
                        Day After Tomorrow{" "}
                      </p>
                    </div>
                  </Col>
                  <Col className="d-flex justify-content-center">
                    <div className="form-check form-check-custom form-check-solid">
                      <p
                        className={clsx(
                          selectedNextDay
                            ? "form-check-label fs-16 fw-600 text-white"
                            : "form-check-label fs-16 fw-600 text-dark"
                        )}
                      >
                        {Method.getDateAfterDays(
                          Method.getTodayDate("DD-MM-YYYY"),
                          2,
                          "DD-MM-YYYY"
                        )}
                      </p>
                    </div>
                  </Col>
                </Col>
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-top-0">
          <Button className="uw-btn uw-btn-primary uw-btn-lg"
            size="lg"
            onClick={() => {
              let selectedDate;
              if (selectedToday) {
                selectedDate = Method.getTodayDate("YYYY-MM-DD");
              } else if (selectedTomorrow) {
                selectedDate = Method.getDateAfterDays(
                  Method.getTodayDate("YYYY-MM-DD"),
                  1,
                  "YYYY-MM-DD"
                );
              } else if (selectedNextDay) {
                selectedDate = Method.getDateAfterDays(
                  Method.getTodayDate("YYYY-MM-DD"),
                  2,
                  "YYYY-MM-DD"
                );
              }
              localStorage.setItem(
                "dataFromModal",
                JSON.stringify({
                  date: selectedDate,
                })
              );
              props.onSave(selectedDate);
            }}
            disabled={props.loading}
            style={{
              cursor: props.loading ? "not-allowed" : "pointer",
            }}
          >
            {!props.loading && (
              <span className="indicator-label"> Save Changes</span>
            )}
            {props.loading && (
              <span className="indicator-progress" style={{ display: "block" }}>
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SelectPlanDateReview;
